import Loading from 'components/Loading'
import React from 'react'

const Apple: React.FC = () => {
  return (
    <Loading />
  )
}

export default Apple